import {Component, ElementRef, HostListener, inject, Input, OnInit} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {BaseComponent, WmsDialogComponent} from "@wms/components";
import {BsDropdownDirective} from "ngx-bootstrap/dropdown";
import {VcsService} from "@wms/app/vcs/services/vcs.service";
import {VcsAPIService} from "@wms/app/vcs/services/vcs-api/vcs-api.service";
import {DialogService, NotificationService} from "@wms/services";
import {
  WmsVcsProjectChangesDialogComponent
} from "@wms/app/vcs/components/wms-vcs-dialog/wms-vcs-project-changes-dialog/wms-vcs-project-changes-dialog.component";
import { ProjectUpdatesService } from "@wms/app/project-updates/services/project-updates/project-updates.service";
import {JobMenuComponent} from "@wms/app/jobs/component/job-menu/job-menu.component";
import {TabsModule} from "ngx-bootstrap/tabs";
import {JobStatusService} from "@wms/app/jobs/service/job-status.service";

@Component({
  selector: 'wms-project-updates-list',
  standalone: true,
  imports: [
    NgIf,
    WmsDialogComponent,
    WmsVcsProjectChangesDialogComponent,
    NgForOf,
    JobMenuComponent,
    TabsModule
  ],
  templateUrl: './project-updates-list.component.html',
  styleUrls: ['./project-updates-list.component.less']
})
export class ProjectUpdatesListComponent extends BaseComponent implements OnInit {
  @Input() dropdown: BsDropdownDirective;
  projectDetails: any;

  private vcsService = inject(VcsService);
  private vcsApiService = inject(VcsAPIService);
  private dialogService = inject(DialogService);
  private notificationService = inject(NotificationService);
  public projectUpdatesService = inject(ProjectUpdatesService);
  public jobstatusService = inject(JobStatusService);

  isOpen = false;

  constructor(public dropdownMenuEle: ElementRef) {
    super();
  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.dropdown.isOpen) {
      this.dropdown.isOpen = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (!this.dropdownMenuEle.nativeElement.contains(event.target) && this.dropdown.isOpen) {
      this.dropdown.isOpen = false;
    }
  }

  pullChanges() {
    this.vcsApiService.pullChanges().then(() => {
      this.notificationService.show(
        'success',
        '',
        this.locale['MESSAGE_VCS_PULL_SUCCESS']
      );
      window.location.reload();
    }).catch((errObj) => {
      this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, this.locale.MESSAGE_VCS_PULL_FAILURE);
    });
  }

  showDetails() {
    this.vcsService.openDialogWithId('projectChangesDialog');
  }

  openSourceCodeUpdatesDialog() {
    this.dialogService.open('sourceCodeUpdatesDialog');
  }

  ngOnInit(): void {
    this.projectDetails = this.projectService.getDetails();
  }

  protected readonly name = name;
}
